import { useState } from "react"
import { toast } from "react-toastify"

import { useLazyGetClientQuery } from "store/api/clientApi"
import { ApiTypes } from "types"

import { EditCustomerModal } from "modals/EditCustomerModal"

const useCustomerEditModal = () => {
  const [showModal, setShowModal] = useState(false)
  const [customer, setCustomer] = useState<ApiTypes.Model.ClientDevices | undefined>(undefined)
  const [triggerGetClient] = useLazyGetClientQuery()

  const onShowEditCustomerModal = async (id: number) => {
    try {
      const res = await triggerGetClient(id)
      if (res.data?.data) {
        setShowModal(true)
        setCustomer(res.data.data)
      }
    } catch (error) {
      toast.error(error as string)
    }
  }

  const renderEditCustomerModal = () => {
    if (!showModal || !customer) return null

    return <EditCustomerModal customer={customer} onCancel={() => setShowModal(false)} />
  }

  return { onShowEditCustomerModal, renderEditCustomerModal }
}

export default useCustomerEditModal
